<script setup>
import Track from './Track.ce.vue'
import LockIcon from '../../assets/lock.svg'

const props = defineProps({
  count: {
    type: Number,
    required: true,
  },
})

let placeholders = [
  { position: 1, title: 'Hier geven we', artist: { name: 'Geen geheimen prijs' }, stats: { position: 1, previousPosition: 1 } },
  { position: 2, title: 'Sorry', artist: { name: 'Not sorry' }, stats: { position: 2, previousPosition: 2 } },
]
</script>

<template>
  <div class="hidden-tracks">
    <div class="hidden-tracks__tracks">
      <Track v-for="placeholder in placeholders" :key="placeholder.position" v-bind="placeholder" />
    </div>
    <div class="hidden-tracks__message">
      <LockIcon class="hidden-tracks__icon" />
      <p>De top {{count}} houden we nog even geheim</p>
    </div>
  </div>
</template>

<style lang="scss">
.hidden-tracks {
  position: relative;
  &__tracks {
    filter: blur(10px);
    user-select: none;
    pointer-events: none;

    .track-cover {
      background-color: rgb(var(--color-highlight) / 0.6);
    }
  }

  &__icon {
    width: 48px;
    height: 48px;
    path {
      fill: rgb(var(--color-primary));
    }
  }

  &__message {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    p {
      margin-top: 0.5rem;
      font-family: var(--font-title);
      font-weight: 600;
      font-size: 1.5rem;
      text-transform: uppercase;
      color: rgb(var(--color-highlight));
    }
  }
}
</style>